import { changelogComponent } from './changelog.component';

export const changelogStateName = 'app.changelog';

export const changelogState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state('changelog', {
    url: '/changelog',
    name: changelogStateName,
    component: changelogComponent.name,
  });
};



// WEBPACK FOOTER //
// ./src/app/components/changelog/changelog.state.js